import { all, keys } from 'ramda'

export default function structureMatches(a, b) {
	return all(key => {
		return (typeof(a[key]) == typeof(b[key])
			&& (typeof(a[key]) != 'object' || structureMatches(a[key], b[key])))
	})(keys(a))
}



// WEBPACK FOOTER //
// ./src/utils/structureMatches.js